import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// Estilos
import styles from './empresaspage.module.css';

// Assets

// API
import { useEmpresaService } from '../../services/empresaServices';

function EmpresasPage() {
    const { logout } = useAuth();
    const { showToast } = useToast();
    const { showLoader, hideLoader } = useLoader();
    const { showModal } = useModal();
    const navigate = useNavigate();

    const { listarEmpresas, deletarEmpresa } = useEmpresaService();

    const [empresas, setEmpresas] = useState([]);

    useEffect(() => {
        const carregarEmpresas = async () => {
            showLoader("Buscando empresas");

            const response = await listarEmpresas();

            if (response.success) {
                const dadosFormatados = response.data.map((empresa) => ({
                    id: empresa.id,
                    name: empresa.nome,
                }));

                setEmpresas(dadosFormatados);
            } else {
                showToast('Erro ao carregar empresas: ' + response.message, 3000, 'error');
                if (response.message?.toLowerCase().includes('token')) logout();
            }

            hideLoader();
        };

        carregarEmpresas();
    }, []);

    const handleEditar = (item) => {
        navigate(`/empresas/atualizar/${item.id}`);
    };

    const handleExcluir = (item) => {
        showModal(
            `Excluir ${item.name}?`,
            'Essa ação não poderá ser desfeita.',
            async () => {
                showLoader("Excluindo empresa");

                const response = await deletarEmpresa(item.id);

                if (response.success) {
                    showToast('Empresa excluída com sucesso!', 3000, 'success');
                    setEmpresas((prev) => prev.filter((e) => e.id !== item.id));
                } else {
                    showToast('Falha ao excluir empresa.', 3000, 'error');
                    console.log(response.message);

                    if (response.message?.toLowerCase().includes('token')) logout();
                }

                hideLoader();
            },
            () => {
                showToast('Exclusão cancelada.', 2000);
            }
        );
    };

    const handleSelecionar = (item) => {
        navigate(`/empresas/${item.id}`);
    };

    const handleAdd = async () => {
        navigate('/empresas/adicionarEmpresa');
    };

    return (
        <div className={styles.EmpresasPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs />
                
                <h1 className={styles.title}>Empresas Cadastradas</h1>
                <FriendlyPhrase />
            </div>

            <div className={styles.containerList}>
                <ItemList
                    items={empresas}
                    onAdd={handleAdd}
                    onEdit={handleEditar}
                    onDelete={handleExcluir}
                    onClickItem={handleSelecionar}
                />
            </div>
        </div>
    );
}

export default EmpresasPage;